import { RootStore } from 'store/rootStore';
import { makeAutoObservable, runInAction } from 'mobx';
import { EDateZipInfo } from 'types/policyService';
import { getAllEnrollmentPeriodsByGroupId } from 'api/operations/enrollmentService';
import { getAdditionalOutputsZipByPeriodIds, getFinalZipsByPeriodIds } from 'api/operations/policyService';

export class AttachmentsStore {
  rootStore: RootStore;
  zipInfoList: EDateZipInfo[] = [];
  loading = false;
  isRenewalExhibitsModalOpen = false;

  private setLoading(status: boolean): void {
    this.loading = status;
  }

  public setRenewalExhibitsModalOpenStatus(status: boolean): void {
    this.isRenewalExhibitsModalOpen = status;
  }

  public async getFinalZipsByPeriodIds(groupId: string): Promise<void> {
    this.setLoading(true);
    const result = await getAllEnrollmentPeriodsByGroupId(groupId);
    void runInAction(async () => {
      if (result.length > 0) {
        const periodIds = result.map(({ id }) => id);

        const results = await Promise.all([
          getFinalZipsByPeriodIds(periodIds),
          getAdditionalOutputsZipByPeriodIds(periodIds),
        ]);

        runInAction(() => {
          this.zipInfoList = [...results[0], ...results[1]];
          this.setLoading(false);
        });
      }
    });
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
